import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId } from "./utils";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-navy/80 backdrop-blur-xl border-b border-white/[0.06]"
          : "bg-transparent border-b border-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="mx-auto max-w-[1240px] px-6 md:px-12 h-[72px] flex items-center justify-between">
        <button
          onClick={() => scrollToId("hero")}
          className="flex items-center transition-opacity hover:opacity-80"
          data-testid="header-logo"
          aria-label="SalesMoat home"
        >
          <Logo className="h-8 md:h-9 w-auto" />
        </button>

        <button
          onClick={() => scrollToId("waitlist")}
          data-testid="header-request-access"
          className="group inline-flex items-center gap-1.5 text-sm font-medium text-slate-200 hover:text-white transition-colors"
        >
          Request Early Access
          <ArrowUpRight className="h-4 w-4 text-teal transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </button>
      </div>
    </motion.header>
  );
};
